"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("../utils/safeInstanceOf");
/**
 * Get innerHTML of the given node
 * @param node The DOM node to get innerHTML from
 */
function getInnerHTML(node) {
    if (safeInstanceOf_1.default(node, 'HTMLElement')) {
        return node.innerHTML;
    }
    else if (node) {
        var tempNode = node.ownerDocument.createElement('span');
        tempNode.appendChild(node.cloneNode(true /*deep*/));
        return tempNode.innerHTML;
    }
    else {
        return '';
    }
}
exports.default = getInnerHTML;
//# sourceMappingURL=getInnerHTML.js.map